export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/step-store.8e7da837-f449a1.png";